import { PDFDocument } from 'pdf-lib';

/**
 * Converte Uint8Array ou ArrayBuffer para base64
 */
function toBase64(data: Uint8Array | ArrayBuffer): string {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  let binary = '';

  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary);
}

/**
 * Converte base64 para Uint8Array
 */
function fromBase64(base64: string): Uint8Array {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes;
}

/**
 * FUNÇÃO PRINCIPAL: Concatenar PDFs (base64) usando pdf-lib
 */
async function concatBase64Array(base64Array: string[]): Promise<string> {
  console.log(`concatenating ${base64Array.length} PDFs...`);

  // 1. Criar novo documento
  const pdfMerged = await PDFDocument.create();

  // 2️. Processar cada PDF
  for (let i = 0; i < base64Array.length; i++) {
    console.log(`   Processing ${i + 1}/${base64Array.length}...`);

    // Converter base64 → Uint8Array
    const pdfBytes = fromBase64(base64Array[i]);

    // Carregar PDF
    const pdfDoc = await PDFDocument.load(pdfBytes);

    // Copiar páginas
    const pages = await pdfMerged.copyPages(
      pdfDoc,
      pdfDoc.getPageIndices()
    );

    // Adicionar páginas
    pages.forEach((page) => pdfMerged.addPage(page));
  }

  // 3. Salvar como Uint8Array
  const mergedBytes = await pdfMerged.save();

  // 4. Converter para base64
  const base64Result = toBase64(mergedBytes);

  console.log(`PDFs concatenated!`);
  return base64Result;
}

export const PdfConcatHelper = {
  concat: concatBase64Array,
}